<script>
import moment from 'moment-timezone';

import VsDate from './VsDate';
import VsInput from './VsInput';
import VsLayout from './VsLayout';

export default {
  components: {
    VsDate,
    VsLayout,
    VsInput,
  },
  props: {
    searchText: String,
    searchPlaceholder: String,
    hideSearch: String,
    hideDate: String,
    timezone: String,
    fixed: String,
  },
  data: () => ({
    moment,
  }),
  methods: {
    disableAfterToday(date) {
      return moment(date).isAfter(moment().endOf('day'));
    },
  },
};
</script>

<template lang='pug'>
.vs-table__controls-container(:class='{ "vs-table__controls-container--fixed": fixed }')
  vs-layout.vs-table__inputs-container(
    wrap-xs,
    no-gutter,
    margin-bottom='1',
  )
    vs-layout(
      v-if='!hideDate',
      no-gutter-left-lg,
      lg='6',
      xl='4',
      margin-top='1',
    )
      vs-date(
        ref='datePicker',
        clearable,
        is-range-picker,
        placeholder='Dates',
        :disable-after='moment.tz(timezone).endOf("day")',
        :timezone='timezone',
        @date-range-changed='$emit("container-date-changed", $event)',
      )
    vs-layout(
      v-if='!hideSearch',
      no-gutter-right-lg,
      lg='6',
      xl='4',
      margin-top='1',
    )
      vs-input(
        clearable,
        full-width,
        :placeholder='searchPlaceholder',
        :value='searchText',
        @input='$emit("search", $event.target.value)',
      )
</template>